import { squadStatusBarContainer } from "./squadStatusBar.css";
import { SquadStatusBarProps } from "./types";

/**
 * SquadStatusBar - Displays a status message with an accessible live region
 * for announcing dynamic content changes such as elements data length or
 * transfer status.
 *
 * @param children - Text content to display (e.g., "570 players shown", "You are about to transfer 1 player!").
 * @param isLiveRegion - When true, the component functions as an ARIA live region to announce dynamic content changes to screen readers.
 */

const SquadStatusBar = ({ children, isLiveRegion }: SquadStatusBarProps) => (
  <div
    className={squadStatusBarContainer}
    role={isLiveRegion ? "status" : undefined}
  >
    {children}
  </div>
);

export default SquadStatusBar;
